









































































































import { organization, ParamsInfo, DataInfo } from '@/api/organization'
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Pagination from '@/components/Pagination/index.vue'
import { organizationStatus } from '@/utils/enum/enum.ts'

@Component({
  components: {
    Pagination
  }
})
export default class Organization extends Vue {
  private organizationList: DataInfo[] = []
  private total: number = 0

  private paramsInfo: ParamsInfo = {
    organizationName: '',
    pageNum: 1,
    pageSize: 10
  }

  private dataInfo: DataInfo = {
    id: 0,
    name: '',
    contactAddress: '',
    contactPerson: '',
    contactPhone: '',
    roles: []
  }

  private dialogFormVisible: boolean = false
  private dialogTitle = ''

  private rules = {
    name: [{ required: true, message: '请输入组织', trigger: 'change' }],
    contactAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
    contactPerson: [{ required: true, message: '请输入联系人', trigger: 'change' }],
    contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'change' }],
    roles: [{ required: true, message: '请选择至少一个组织权限', trigger: 'change' }]
  }

  private created() {
    this.fetchData()
    this.queryTotal()
  }

  // 查询数据
  private fetchData() {
    organization('GET', this.paramsInfo, null, '/page').then((response: any) => {
      this.organizationList = response
      // console.log(response)
    })
    .catch((err: any) => {
        console.log('catch' + err) // catch error
    })
  }
  private queryTotal() {
    let params = Object.assign({}, this.paramsInfo)
    delete params.pageNum
    delete params.pageSize
    organization('GET', params, null, '/Count').then((response: any) => {
      this.total = response
    })
  }
  private handleSearch() {
    this.paramsInfo.pageNum = 1
    this.paramsInfo.pageSize = 10
    this.fetchData()
    this.queryTotal()
  }

  private resetTemp() {
    this.dataInfo = {
      id: 0,
      name: '',
      contactAddress: '',
      contactPerson: '',
      contactPhone: '',
      roles: []
    }
  }

  private handleCreate() {
    this.dialogTitle = '新增组织'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.resetTemp()
    })
  }

  // 创建数据
  private createData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        let insertData = Object.assign({}, this.dataInfo)
        delete insertData.id
        organization('POST', null, insertData).then((response: any) => {
          this.dialogFormVisible = false
          this.$message.success('新增组织成功')
          this.fetchData()
          this.queryTotal()
        })
      }
    })
  }

  private handleUpdate(row: any) {
    this.dialogTitle = '编辑组织'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.dataInfo = Object.assign({}, row) // copy obj
    })
  }

  // 修改数据
  private updateData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        const tempData = Object.assign({}, this.dataInfo)
        organization('PUT', null, tempData).then((response: any) => {
          this.dialogFormVisible = false
          this.$message.success('编辑成功')
          this.fetchData()
          this.queryTotal()
        })
      }
    })
  }

  // 删除
  private deleteOrganization(row: any) {
    this.$confirm(`此操作将把 ${row.name} 该组织移除, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      organization('DELETE', null, [row.id]).then( (res: any) => {
        this.$message({ type: 'success',  message: '删除成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消删除' })
    })
  }
  // 添加组织用户--- 进入详情页:
  private createUser(rowData: any) {
    this.$router.push({
      name: 'accountInformation',
      path: '/organization/accountInformation',
      query: { currentOrganization: rowData.id }
    })
  }

  //  input 只能是数字
  // private handleInput(val: any) {
  //   this.dataInfo.emergencyCall = val.replace(/[^\d]/g, '')
  // }
  // 冻结组织
  private freezeOrganization(row: any) {
    this.$confirm(`此操作将把 ${row.name} 该组织冻结, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      organization('PUT', { organizationId: row.id }, null, '/Frozen').then( (res: any) => {
        this.$message({ type: 'success',  message: '冻结成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消冻结' })
    })
  }
}
